import { cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import { InputAlert } from '@creditornot/cb-input';
import React from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
  label: string;
  children?: React.ReactNode;
  hint?: string;
};

const Root = styled.div``;

const Label = styled.div`
  ${typographyCss.Body3}
  color: ${cssThemedValue('textSecondary')};
`;

const Value = styled.div`
  ${typographyCss.Body3}
  color: ${cssThemedValue('textPrimary')};
  margin-block-start: 4px;
`;

const Hint = styled(InputAlert).attrs({ variant: 'info' })`
  margin-block-start: 4px;
`;

const FormValueContainer = ({ className, label, children, hint }: Props) => {
  return (
    <Root className={className}>
      <Label>{label}</Label>
      <Value>{children}</Value>
      {hint && <Hint variant="info">{hint}</Hint>}
    </Root>
  );
};

export default FormValueContainer;
